/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="drag-drop-div">\n    <table class="drag-drop-table">\n        <tbody>\n        <tr>\n            <td>\n                <div class="drag-drop-container">\n                    <div class="drag-drop-table-blue">\n                        <span class="glyphicon glyphicon-download-alt"></span>\n                        <div>\n                            <br>\n                            Drop files here\n                        </div>\n                    </div>\n                    <div class="drag-drop-table-progress">\n                        <div class="progress progress-striped active">\n                            <div class="progress-bar" style="width: 100%"></div>\n                        </div>\n                    </div>\n                    <div class="drag-drop-table-green">\n                        <span class="glyphicon glyphicon-check" style="color: #4b8b41"></span>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/documents/DragDropView.ejs
// module id = 898
// module chunks = 1